// Messages for portal/Search (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.search.head': 'Search',
  'portal.search.title': 'Search',
  'portal.search.placeholder': 'Shipments, quotes, invoices…',
  'portal.search.submit': 'Search',
  'portal.search.recent': 'Recent: ',
  'portal.search.no_matches': 'No matches.',
}

export const zhTW = {
  'portal.search.head': '搜尋',
  'portal.search.title': '搜尋',
  'portal.search.placeholder': '貨件、報價、發票…',
  'portal.search.submit': '搜尋',
  'portal.search.recent': '最近搜尋：',
  'portal.search.no_matches': '沒有符合的結果。',
}
